'use client';
import React from 'react';
import { CartItemsPreview as Shared } from '@launchstore/shared-puck';
import { useCart } from '@/lib/hooks/useCart';
import { convertToLocale } from '@lib/util/money';

const SharedRender = (Shared as any).render;

/**
 * Storefront CartItemsPreview — binds the real Medusa cart (from useCart)
 * into the shared presentational component. Falls back to the shared MOCK
 * only when no cart is loaded (e.g. editor preview without sample data),
 * so on the live store the shopper always sees the items they actually
 * added — never the placeholder T-Shirt + Jeans.
 */
function CartItemsPreviewImpl(props: any) {
  const { cart, isLoading } = useCart() as any;

  if (isLoading && !cart) {
    return <></>;
  }

  if (!cart) {
    // No cart loaded (editor preview without Medusa backend, or before
    // first fetch resolves). Pass undefined so the shared component
    // falls back to its built-in MOCK for design-time preview.
    return <SharedRender {...props} items={undefined} />;
  }

  const currency = cart.currency_code || 'usd';
  const fmt = (amount: number) =>
    convertToLocale({ amount: Number(amount) || 0, currency_code: currency });

  const items = (cart.items ?? []).map((i: any) => ({
    id: i.id,
    title: i.title ?? i.product_title ?? '',
    variant: i.variant?.title ?? i.variant_title ?? '',
    image: i.thumbnail,
    quantity: i.quantity ?? 1,
    price: fmt(i.unit_price),
    total: fmt(i.total ?? (Number(i.unit_price || 0) * (i.quantity ?? 1))),
  }));

  return <SharedRender {...props} items={items} />;
}

export const CartItemsPreview: any = {
  ...Shared,
  render: (props: any) => <CartItemsPreviewImpl {...props} />,
};
export default CartItemsPreview;
